import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Organization } from '../organization';
import { BulkUploadTaskStatus } from './bulk-upload-task-status.enum';

export class BulkUploadTask extends BaseEntity {
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	createdBy: string;
	bulkFile: string;
	status: BulkUploadTaskStatus;
}
